import { render } from "./qr_read.vue?vue&type=template&id=b54c53b4&scoped=true"
import script from "./qr_read.vue?vue&type=script&lang=js"
export * from "./qr_read.vue?vue&type=script&lang=js"

import "./qr_read.vue?vue&type=style&index=0&id=b54c53b4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\holo\\project\\non-contact-reception\\no-contact\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b54c53b4"]])

export default __exports__